
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/templates/[slug]",
      function () {
        return require("private-next-pages/dashboard/templates/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/templates/[slug]"])
      });
    }
  